import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import React from "react";
import {
  BaseGrid,
  StyledTableRow,
  TableCellHeader,
  TableCellWidth,
  TitleTypography,
} from "../KandidatViewPage";
import { SusunanKeluargaResponse } from "../../../models/SusunanKeluarga";

type Props = { data: SusunanKeluargaResponse[]; title: string };

export default function DataKeluargaKandidatPage({ data, title }: Props) {
  return (
    <BaseGrid container item xs={12} justifyContent="center">
      <Grid
        container
        item
        xs={12}
        sx={{
          backgroundColor: "#00ACED",
          color: "#fff",
          marginBottom: "4%",
        }}
      >
        <TitleTypography>{title}</TitleTypography>
      </Grid>
      <Grid container item xs={12}>
        {/* {data.map((item, key) => (
          <Grid
            container
            item
            xs={5}
            key={key}
            sx={{
              width: "90%",
              height: "auto",
              border: "black 1px solid",
              borderRadius: "10px",
              padding: "1% 2% 2% 2%",
              margin: "2%",
            }}
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Grid container item xs={5.5} direction="column">
              <SubTitleTypography>
                {item.HUBUNGAN_KELUARGA}{" "}
                {item.JENIS_KELAMIN === "Perempuan" ? "(P)" : "(L)"}
              </SubTitleTypography>
              <Typography>
                {item.NAMA} {item.ALMARHUM ? "(Alm.)" : ""}
              </Typography>
              <SubTitleTypography>Tempat, Tanggal Lahir</SubTitleTypography>
              <Typography>
                {item.TEMPAT_LAHIR}
                {item.TANGGAL_LAHIR ? ` , ${item.TANGGAL_LAHIR}` : " , -"}
              </Typography>
            </Grid>

            <Grid container item xs={5.5} direction="column">
              <SubTitleTypography>Pendidikan</SubTitleTypography>
              <Typography>{item.PENDIDIKAN}</Typography>
              <SubTitleTypography>Pekerjaan Terakhir</SubTitleTypography>
              <Typography sx={{ wordBreak: "break-word" }}>
                {item.JABATAN_TERAKHIR}{" "}
                {item.PERUSAHAAN_TERAKHIR
                  ? `di ${item.PERUSAHAAN_TERAKHIR}`
                  : "-"}
              </Typography>
            </Grid>
          </Grid>
        ))} */}
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "rgba(0,0,0,0.1)",
                }}
              >
                <TableCellHeader>Keluarga</TableCellHeader>
                <TableCellHeader>Gender</TableCellHeader>
                <TableCellHeader>Nama</TableCellHeader>
                <TableCellHeader>Tempat, Tanggal Lahir</TableCellHeader>
                <TableCellHeader>Pend.</TableCellHeader>
                <TableCellHeader>Perusahan</TableCellHeader>
                <TableCellHeader>Jabatan</TableCellHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, key) => (
                <StyledTableRow
                  key={key}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCellWidth>{row.HUBUNGAN_KELUARGA}</TableCellWidth>
                  <TableCellWidth>
                    {row.JENIS_KELAMIN === "Perempuan" ? "P" : "L"}
                  </TableCellWidth>
                  <TableCellWidth>
                    {row.NAMA} {row.ALMARHUM ? "(Alm.)" : ""}
                  </TableCellWidth>
                  <TableCellWidth>
                    {row.TEMPAT_LAHIR}
                    {row.TANGGAL_LAHIR ? ` , ${row.TANGGAL_LAHIR}` : " , -"}
                  </TableCellWidth>
                  <TableCellWidth>
                    {row.PENDIDIKAN ? row.PENDIDIKAN : "-"}
                  </TableCellWidth>
                  <TableCellWidth>
                    {row.PERUSAHAAN_TERAKHIR ? row.PERUSAHAAN_TERAKHIR : "-"}
                  </TableCellWidth>
                  <TableCellWidth>
                    {row.JABATAN_TERAKHIR ? row.JABATAN_TERAKHIR : "-"}
                  </TableCellWidth>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </BaseGrid>
  );
}
